import axios from 'axios'
// import store from '../store'

const price_man = axios.create({
    //withCredentials: true,
    //baseURL:'http://localhost:3000/api/v1/',
    baseURL: 'https://tatabyebye.cyou/api/v1/',
    //headers: {
    //    "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfaWQiOjEsInR5cGUiOjEsInVzZXJfaWQiOjEsImlhdCI6MTYwMTY5NzIwNCwiZXhwIjoxNjE3MjQ5MjA0fQ.zwAYxXG0Ft1EFVtLh-Gl_gbdK8mFtKwBLEWN-xVbFcg"
    //}
});


price_man.interceptors.request.use(function (config) {
    let authKey = localStorage.token
    config.headers["Authorization"] = authKey;
    return config;
});


window.price_man = price_man

export default price_man